import React from "react";
import PropTypes from "prop-types";
import {
  DefaultTheme,
  ThemeProvider as StyledThemeProvider,
} from "styled-components";
import { createContext, useContext } from "react";
import GlobalStyle from "./globalStyle";

type ThemeProviderProps = {
  theme: DefaultTheme;
  children: React.ReactNode;
};

const ThemeContext = createContext<DefaultTheme | undefined>(undefined);

const ThemeProvider = ({ theme, children }: ThemeProviderProps) => {
  return (
    <ThemeContext.Provider value={theme}>
      <StyledThemeProvider theme={theme}>
        {/*<GlobalStyle theme={theme} />*/}
        {children}
      </StyledThemeProvider>
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

const useTheme = () => {
  const theme = useContext(ThemeContext);
  if (theme === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return theme;
};

export { ThemeProvider, useTheme };
